import script from "./Input.vue?vue&type=script&setup=true&lang=js"
export * from "./Input.vue?vue&type=script&setup=true&lang=js"

import "./Input.vue?vue&type=style&index=0&id=38c8fbb0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38c8fbb0"]])

export default __exports__